import styled from '@emotion/styled';
// ---- external imports ----

import leftProjection from '~/assets/images/baseAssets/left.png';
import { withProjection } from '~/hoc';
// ---- internal imports ----

import Asset from '../BaseAssets';
// ---- parent imports ----


const LeftArrowButton = styled(
	withProjection(Asset.Button, leftProjection))`
	${({ disabled }) => disabled ? 'display:none;' : ''}
`;


export default LeftArrowButton;
